import { render, staticRenderFns } from "./PaymentPolicy.vue?vue&type=template&id=0978677a&"
import script from "./PaymentPolicy.vue?vue&type=script&lang=js&"
export * from "./PaymentPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PaymentPolicy.vue"
export default component.exports